<template>
  <div>
    <div id="about">
      <p>Want to go somewhere but don't know exactly where?</p>
      <p>Follow the steps below to figure out where!</p>
    </div>
    <div id="wizard">
      <div>
        <div class="tab" v-on:click="setSceneOrigin()">
          <div class="data left" v-bind:class="{ active: ifo, disabled: ifo }">
            <div class="step">
              <i v-if="origin" class="fa fa-check"></i>
              Step 1
            </div>
            <div class="label">Origin</div>
            <div class="text" v-if="origin">{{ origin.name }}</div>
            <div class="text" v-else>Choose origin</div>
          </div>
          <span v-if="ifo" class="sha"/>
          <!-- <span v-if="ifo" class="arrow"/> -->
          <span v-if="ifo" class="bbb"/>
        </div><div class="tab" v-on:click="sceneDestination()">
          <div class="data" v-bind:class="{ active: ifd, disabled: ifd || !origin }">
            <div class="step">
              <i v-if="destination" class="fa fa-check"></i>
              Step 2
            </div>
            <div class="label">Destination</div>
            <div class="text" v-if="destination">{{ destination.name }}</div>
            <div class="text" v-else>Choose destination</div>
          </div>
          <span v-if="ifd" class="sha"/>
          <!-- <span v-if="ifd" class="arrow"/> -->
          <span v-if="ifd" class="bbb"/>
        </div><div class="tab" v-on:click="sceneFlight()">
          <div class="data right" v-bind:class="{ active: iff, disabled: iff || !origin || !destination }">
            <div class="step">Step 3</div>
            <div class="label">Flight</div>
            <div class="text" v-if="flight">{{ flight.name }}</div>
            <div class="text" v-else>Choose flight</div>
          </div>
          <span v-if="iff" class="sha"/>
          <!-- <span v-if="iff" class="arrow"/> -->
          <span v-if="iff" class="bbb"/>
        </div>
      </div>

      <div id="content">
        <origins v-if="ifo"/>
        <destinations v-if="ifd"/>
        <flights v-if="iff"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ORIGIN, DESTINATION, FLIGHT } from '../store'

import Origins from './Origins'
import Destinations from './Destinations'
import Flights from './Flights'

export default {
  name: 'wizard',
  data () {
    return {
      transition: 'slide-right'
    }
  },
  computed: {
    ...mapState({
      origin: state => state.origin,
      destination: state => state.destination,
      flight: state => state.flight,
      ifo: state => state.scene === ORIGIN,
      ifd: state => state.scene === DESTINATION,
      iff: state => state.scene === FLIGHT
    })
  },
  methods: {
    sceneDestination: function () {
      if (!this.origin) return
      this.setSceneDestination()
    },
    sceneFlight: function () {
      if (!this.origin || !this.destination) return
      this.setSceneFlight()
    },
    ...mapActions([
      'setSceneOrigin',
      'setSceneDestination',
      'setSceneFlight'
    ])
  },
  components: {
    Origins,
    Destinations,
    Flights
  }
}
</script>

<style scoped>
#about {
  font-family: 'Maven Pro', sans-serif;
  color: #fff;
  text-shadow: 1px 1px 1px #898989;
  font-size: 24px;
  padding: 21px;
}
#about p {
  margin: 0;
  padding: 5px;
}
#wizard {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  /*background: white;*/
  /*box-shadow: 0px 1px 9px #6e6e6e99;*/
  border-radius: 2px;
  font-family: 'Maven Pro', sans-serif;
  padding: 31px;
  background: #e6e6e6;
}
#content {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}
.tab {
  display: inline-block;
  width: 33.333333333%;
  margin: 0;
  padding: 0;
  position: relative;
  margin-bottom: 17px;
  line-height: 27px;
  user-select: none;
}

.data {
  text-align: left;
  padding: 5px 11px;
  background-color: #fff;
  color: #8f8f8f;
    text-shadow: none;
    margin-left: 1px;
    margin-right: 1px;
box-shadow: 1px 1px 1px #939393;

}

.data:hover {
  cursor: pointer;
  /*box-shadow: 1px 1px 0px #686868;*/
  /*border-right: 1px solid #9c9c9c;*/
  /*border-bottom: 1px solid #877f7f;*/
  box-shadow: 1px 1px 1px #444;
}
.data.active {
  background-color: #62c7dd;
  /*border: 1px solid #36b8d4;*/
  color: #fff;
  text-shadow: 1px 1px 1px #898989;
  border-color: #68b4c5;
}
.data.active:hover {
  /*box-shadow: 1px 1px 0px #939393;*/
  /*border-right: 1px solid #c5c1c1;*/
/*border-bottom: 1px solid #bab5b5;*/
border-color: #68b4c5;
}
.data.active.disabled:hover {
  border-color: #68b4c5;
}

.data.disabled:hover {
  cursor: default;
  /*border-right: 1px solid #c5c1c1;*/
/*border-bottom: 1px solid #bab5b5;*/
box-shadow: 1px 1px 1px #939393;
}




.label {
  font-size: 18px;
  /*color: white;*/
  /*padding: 11px 15px 5px;*/

}
/*.label.active {
  font-size: 30px;
}*/
.text {
  font-size: 18px;
  /*color: white;*/
  font-weight: bold;
  /*padding-left: 15px;*/

}
.text.active {
  bottom: 15px;
}
.left {
  border-top-left-radius: 3px;
}
.right {
  border-top-right-radius: 3px;
}
/*.arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 50px 0 50px 14px;
  border-color: transparent transparent transparent #62c7dd;
  position: absolute;
  right: -7px;
  top: 0;
}*/

.sha {
  bottom: -18px;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  /*border-top-color: #ededed;*/
  border-top-color: #939393;
  border-width: 9px;
  margin-left: -8px;
}

/*.arrow {
  bottom: -20px;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  /*border-top-color: #ededed;*/
  /*border-top-color: #68b4c5;
  border-width: 10px;
  margin-left: -10px;
}*/
.bbb {
	bottom: -19px;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  /*border-top-color: #ededed;*/
  border-top-color: #62c7dd;
  border-width: 10px;
  margin-left: -10px;
}
.step {
  font-size: 10px;
  line-height: 14px;
}
.tab .data {
  border-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// Wizard.vue?243ba9ec